<ags-search></ags-search>
<div class="uk-container uk-margin-top-remove uk-margin-large-bottom">
  <div class="align-right uk-margin-bottom">
    {{ formResList.length ? 1 : 0 }}-{{ formResList.length }} résultat{{formResList.length > 1 ? 's' : ''}}
    affiché{{ formResList.length > 1 ? 's' : '' }} sur {{ searchMatchCount }}
  </div>
  <div *ngIf="!formResList || formResList.length < 1">Aucune formation trouvée</div>
  <div *ngIf="secondSearch">
    Nous n'avons pas trouvé de formation répondant exactement aux critères de recherche mais les formations suivantes
    pourraient vous intéresser
  </div>
  <div class="uk-grid uk-grid-large uk-margin-bottom">
    <div class="bloc-responsive uk-width-1-3" *ngFor="let form of formResList">
      <ags-formation-overview-card [formation]="form"></ags-formation-overview-card>
    </div>
  </div>

  <div class="align-center">
    <button kendoButton [primary]="true" class="colored-text" *ngIf="searchMatchCount > formResList.length" (click)="getMore()">
      AFFICHER PLUS DE RESULTATS
    </button>
  </div>
</div>
